import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import ViewReverse from '../../components/ViewReverse';
import faqsFunctional from './index.function';

const Faqs = () => {
  const {
    TextWeight,
    getContentKey,
    navigate,
    activeIndex,
    setActiveIndex,
    isArabic,
    helpContent,
  } = faqsFunctional();

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className='min-h-full'>
      <ViewReverse className='gap-5 items-center'>
        <ReactSVG
          src={icons?.backSmall}
          className={`cursor-pointer ${isArabic ? 'rotate-180' : ''}`}
          onClick={() => navigate(-1)}
        />
        <Text
          text={getContentKey('faq_heading')}
          color='text-black'
          size={fontSizes.h18}
          weight={TextWeight.bold}
        />
      </ViewReverse>

      <div className='border border-grey rounded-xl mt-8 py-3 px-5 shadow-light'>
        {helpContent?.faq?.data?.attributes?.faqs?.map((item, index) => (
          <div
            key={index}
            className='border-b border-gray-200 last:border-none pt-3 pb-4'
          >
            <ViewReverse
              className='flex justify-between items-center cursor-pointer'
              onClick={() => toggleFAQ(index)}
            >
              <Text
                text={isArabic ? item?.question_arabic : item?.question}
                color='text-black'
                size={fontSizes.h17}
                weight={TextWeight.medium}
              />
              <ReactSVG
                src={
                  activeIndex === index
                    ? icons.Faqs_minus_icon
                    : icons.faq_plus_icon
                }
              />
            </ViewReverse>
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                activeIndex === index
                  ? 'max-h-40 opacity-100 mt-1'
                  : 'max-h-0 opacity-0'
              }`}
            >
              <Text
                text={isArabic ? item?.answer_arabic : item?.answer}
                color='text-gray-600'
                isTruncate={false}
                size={fontSizes.h14}
                weight={TextWeight.regular}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;
